import { FC, useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";
import { useLocation, useNavigation } from "react-router-dom";

import { RootState } from "@store/rootReducer";
import { storeApis } from "@store/store";

import { getIsFirstLoadPending } from "./NavigationProgress.utilities";
import { progressBarHideDelayMs } from "./NavigationProgress.constants";

import LinearProgress from "@mui/material/LinearProgress";

import { progressBarDelayMs } from "@constants";

const NavigationProgress: FC = () => {
  const { key: locationKey } = useLocation();
  const navigation = useNavigation();
  const pageRenderedAtReference = useRef<number | null>(null);
  const renderedLocationKeyReference = useRef<string | null>(null);
  if (renderedLocationKeyReference.current !== locationKey) {
    renderedLocationKeyReference.current = locationKey;
    pageRenderedAtReference.current = Date.now();
  }
  const isFirstLoadPending = useSelector((state: RootState) =>
    getIsFirstLoadPending(
      storeApis.map((api) => state[api.reducerPath].queries),
      pageRenderedAtReference.current,
    ),
  );

  const isLoading = navigation.state === "loading" || isFirstLoadPending;
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(isLoading), isLoading ? progressBarDelayMs : progressBarHideDelayMs);

    return () => clearTimeout(timeout);
  }, [isLoading]);

  if (!isVisible) {
    return null;
  }

  return (
    <LinearProgress
      color="primary"
      data-cy="app-layout-navigation-progress"
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: 3,
        opacity: 0,
        bgcolor: "transparent",
        animation: "navigationProgressFadeIn 150ms ease-out forwards",
        "@keyframes navigationProgressFadeIn": { to: { opacity: 1 } },
      }}
    />
  );
};

export default NavigationProgress;
